<template lang="pug">
  el-row(:gutter="20")
    card(
      v-for="painel in paineis"
      :key="painel.id"
      :isMyProject="isMyProject"
      @onClick="onClick"
      @onEdit="onEdit"
      @onDelete="onDelete"
      :title="painel.nome"
      :body="painel.descricao"
      :id="painel.id"
    )
</template>

<script>
import Card from '@/screens/demandas/components/Card'

export default {
  components: {
    Card
  },

  methods: {
    onClick (event, id) {
      this.$router.push({
        name: 'demandas/demandasPainel',
        query: {
          idPainel: id
        }
      })
    },

    onEdit (event, id) {
      this.$emit('openModal', id)
    },

    onDelete (event, id) {
      this.$emit('delete', id)
    }
  },

  props: {
    paineis: {
      required: true,
      type: Array
    },

    isMyProject: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style scoped lang="scss">
.container {
  height: 100%;
}

.new-project {
  margin-bottom: 40px;
}
</style>



// WEBPACK FOOTER //
// src/screens/demandas/components/ListagemPaineis.vue